import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles, withStyles } from "@mui/styles";
import axios from "axios";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { CheckBox } from "@mui/icons-material";
import {
  Slide,
  Snackbar,
  Grid,
  Checkbox,
  Paper,
  TableRow,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Dialog,
  DialogActions,
  DialogContent,
  Alert,
} from "@mui/material";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
  GreenCheckboxSelected,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

import loaderGif from "assets/img/loading.gif";

const useStyles = makeStyles(cardBodyStyle);

const GreenCheckbox = withStyles(GreenCheckboxSelected)((props) => (
  <Checkbox color="default" {...props} />
));

export default function CompaniesSelectAdmin(props) {
  const classes = useStyles();
  const [selected, setSelected] = useState([]);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [selectedDifferent, setSelectedDifferent] = useState([]);
  const [idSelectCompany, setIdSelectCompany] = useState([]);
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [mensageSystem, setMensageSystem] = useState("");

  const { urlServices, UserAuth } = useContext(UrlServicesContext);
  let keyAuthorization = UserAuth.Session;

  useEffect(() => {
    axios
      .get(`${urlServices}company/list`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        setRows(response.data);

        const initialSelected = props.idRow.row.productsCompany.map(
          (company) => company.companyId
        );

        const idProductsCompany = props.idRow.row.productsCompany.map(
          (data) => ({
            id: data.id,
            companyId: data.company?.id,
          })
        );

        setSelected(initialSelected);
        setSelectedDifferent(idProductsCompany);
        setIdSelectCompany(initialSelected);

        setLoader(false);
      })
      .catch((e) => {
        // Manejo de errores...
      });
  }, [props.idRow.row.productsCompany, keyAuthorization, urlServices]);

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected =
      selectedIndex === -1
        ? [...selected, id]
        : selected.filter((item) => item !== id);

    setSelected(newSelected);
  };

  const handleSave = () => {
    // Obtener empresas que deben ser creadas y eliminadas
    const different = selected.filter(
      (id) => !selectedDifferent.some((data) => data.companyId === id)
    );

    const deleteValue = selectedDifferent.filter(
      (data) => !selected.some((id) => id === data.companyId)
    );

    // Crear registros
    if (different.length > 0) {
      different.forEach((row) => {
        const exists = idSelectCompany.some((companyId) => companyId === row);
        if (!exists) {
          CreateData(row); // Llama a la función para crear el registro
        }
      });
    }

    // Eliminar registros
    if (deleteValue.length > 0) {
      DeleteData(deleteValue); // Llama a la función para eliminar el registro
    }

    setMensaje("Registro guardado con éxito.");
    setOpenAlert(true);
    setSuccess("success");
    props.callBackRefresh();
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const DeleteData = (data) => {
    data.forEach((row) => {
      axios
        .delete(`${urlServices}products-company/${row.id}`, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        })
        .then(
          (response) => {},
          (error) => {}
        )
        .catch((e) => {
          if (e.response.status === 401) {
            setMensageSystem(
              "La sesión ha expirado, vuelva a iniciar sesión ..."
            );
            setError(true);

            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 4000);
          } else if (e.response.status === 500) {
            setMensageSystem("Error en la consulta con sel servidor.");
            setError(true);
          }
        });
    });
  };

  const CreateData = (id) => {
    const dataValue = {
      productsId: props.idRow.row.id,
      companyId: id,
    };

    axios
      .post(`${urlServices}products-company`, dataValue, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then(
        (response) => {},
        (error) => {}
      )
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      onClose={handleCloseDialog(true)}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      keepMounted
      scroll="body"
      PaperProps={{
        sx: {
          borderRadius: 6,
        },
      }}
    >
      <DialogContent dividers className={classes.styleDialogContent}>
        <Card>
          <CardHeader color="info">
            <div className={classes.cardTitleWhite}>
              <CheckBox className={classes.iconWhite} /> Seleccionar empresas
            </div>
          </CardHeader>
          <CardBody>
            <Grid container>
              {error && <Alert severity="error">{mensageSystem}</Alert>}
              {loader ? (
                <Grid item xs={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "8% 0" }}
                    />
                  </center>
                </Grid>
              ) : (
                <Fragment>
                  <Grid item xs={12} sm={6}>
                    <Paper className={classes.paper}>
                      <TableContainer>
                        <Table
                          aria-labelledby="tableTitle"
                          size="small"
                          aria-label="enhanced table"
                        >
                          <TableBody>
                            {rows.map((row, index) => {
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  onClick={(event) =>
                                    handleClick(event, row.id)
                                  }
                                  role="checkbox"
                                  aria-checked={isSelected(row.id)}
                                  tabIndex={-1}
                                  key={index}
                                  selected={isSelected(row.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <TableCell padding="checkbox">
                                    <GreenCheckbox
                                      checked={isSelected(row.id)}
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    id={labelId}
                                    scope="row"
                                    padding="none"
                                  >
                                    {row.name}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Grid>
                  <Grid item xs={12}>
                    <br />
                    <center>
                      <ButtonStyle0 type="button" onClick={handleSave}>
                        Aceptar
                      </ButtonStyle0>
                    </center>
                  </Grid>
                </Fragment>
              )}
            </Grid>
          </CardBody>
        </Card>
        <Snackbar
          open={openAlert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleClose}
        >
          <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleClose}
              severity={success === "error" ? "error" : "success"}
              elevation={6}
              variant="filled"
            >
              {mensaje}
            </Alert>
          </Slide>
        </Snackbar>
      </DialogContent>
      <DialogActions>
        <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
      </DialogActions>
    </Dialog>
  );
}
